import { TablePage } from "~/components/Table";
import { RoleFilters } from "./components/RoleFilters";
import { RoleSearchRequestProvider, RoleTable } from "./components/RoleTable";

export function RolesPage() {
  return (
    <TablePage
      title="Search Roles"
      RequestProvider={RoleSearchRequestProvider}
      table={<RoleTable />}
      filters={<RoleFilters />}
    />
  );
}
